import React, { useState } from "react";
import { reserveAPI } from "../../services/api";

/**
 * Waiting list for a full date, or "tell me when dates open" for a
 * retreat with none. Same form, different promise.
 *
 *   <WaitlistForm pathwayId={12} />       a full date
 *   <WaitlistForm typeId={3} />           no dates yet
 */
const WaitlistForm = ({ pathwayId = null, typeId = null, compact = false }) => {
  const [form, setForm] = useState({ name: "", email: "", guests: 1, website: "" });
  const [state, setState] = useState({ sending: false, done: "", error: "" });
  const waitlist = !!pathwayId;

  const submit = async (e) => {
    e.preventDefault();
    setState({ sending: true, done: "", error: "" });
    try {
      await reserveAPI.waitlist({ ...form, pathway_id: pathwayId, retreat_type_id: typeId });
      setState({ sending: false, done: waitlist
        ? "You're on the waiting list. We'll write the moment a place opens."
        : "Thank you. We'll email you as soon as new dates open.", error: "" });
    } catch (err) {
      setState({ sending: false, done: "", error: err.message });
    }
  };

  if (state.done) return <p className="mk-note mk-note--ok" role="status">{state.done}</p>;

  return (
    <form className={`mk-form ${compact ? "mk-form--compact" : ""}`} onSubmit={submit} noValidate>
      <p className="mk-muted mb-0">
        {waitlist
          ? "This date is full. Leave your details and you'll be first to hear if a place opens."
          : "There are no dates open for this retreat right now. Leave your email and we'll tell you when there are."}
      </p>
      <div className="mk-row">
        <label className="mk-field">
          <span>Name</span>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} autoComplete="name" required />
        </label>
        <label className="mk-field">
          <span>Email</span>
          <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} autoComplete="email" required />
        </label>
      </div>
      {waitlist && (
        <label className="mk-field mk-field--narrow">
          <span>How many of you?</span>
          <input type="number" min={1} max={20} value={form.guests} onChange={(e) => setForm({ ...form, guests: e.target.value })} />
        </label>
      )}
      {/* Bots fill every field; people never see this one. */}
      <input className="mk-hp" tabIndex={-1} autoComplete="off" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} aria-hidden="true" />
      {state.error && <p className="mk-error" role="alert">{state.error}</p>}
      <div>
        <button className="mk-btn mk-btn--primary" disabled={state.sending || !form.name.trim() || !form.email.trim()}>
          {state.sending ? "Sending…" : waitlist ? "Join the waiting list" : "Tell me when"}
        </button>
      </div>
    </form>
  );
};

export default WaitlistForm;
